import React, { useState } from "react";

const FailedAssetsPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showFailedAssetsPopup, setShowFailedAssetsPopup] =
      useState<boolean>(false);

    const failedAssetsToggleHandler = () => {
      setShowFailedAssetsPopup(!showFailedAssetsPopup);
    };

    return (
      <Component
        showFailedAssetsPopup={showFailedAssetsPopup}
        failedAssetsToggleHandler={failedAssetsToggleHandler}
        {...props}
      />
    );
  };

export default FailedAssetsPopupHOC;
